import { render, staticRenderFns } from "./it-faq.vue?vue&type=template&id=4dbcbfd6&"
import script from "./it-faq.vue?vue&type=script&lang=js&"
export * from "./it-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports